/**
 * embed_height_controller.js — report the framed quote form's height to the host page.
 *
 * Mounted on <body> of templates/profile/embed.html, which a business shows in
 * an iframe on its own website. Whenever the body changes height (a refusal
 * appears, photos are previewed, the thank-you replaces the form) it posts
 * {type: 'chippie-embed-height', height} to the parent window, and
 * static/js/embed.js on the host page sizes the iframe to match, so the form
 * never scrolls inside a box. The message carries only a number, so it is
 * posted to any origin. Opened outside a frame, it does nothing.
 *
 * The message shape is a contract with copies of embed.js already pasted on
 * customers' sites: never rename the type or the field.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        if (window.parent === window) return;
        this._observer = new ResizeObserver(() => this._report());
        this._observer.observe(this.element);
        this._report();
    }

    disconnect() {
        if (this._observer) this._observer.disconnect();
    }

    _report() {
        window.parent.postMessage(
            { type: 'chippie-embed-height', height: Math.ceil(this.element.getBoundingClientRect().height) },
            '*'
        );
    }
}
